import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import adminService from '../services/adminService'

/**
 * Independent Admin auth state (Phase 16.4) — completely separate from the
 * customer AuthContext. The admin session lives in the httpOnly `admin_token`
 * cookie (sent automatically via credentials:'include'); this context only holds
 * the current admin identity, fetched from GET /api/admin/auth/me. Used as a
 * layout route so it mounts (and calls /me) ONLY under /admin/*.
 */
const AdminAuthContext = createContext(null)
export const useAdminAuth = () => useContext(AdminAuthContext)

export function AdminAuthProvider () {
  const [admin, setAdmin] = useState(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    try {
      const res = await adminService.adminMe()
      setAdmin(res?.admin || null)
    } catch {
      setAdmin(null)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { refresh() }, [refresh])

  const login = useCallback(async (email, pwd) => {
    const res = await adminService.adminLogin(email, pwd)
    setAdmin(res?.admin || null)
    return res
  }, [])

  const logout = useCallback(async () => {
    try { await adminService.adminLogout() } catch { /* ignore */ }
    setAdmin(null)
  }, [])

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      <Outlet />
    </AdminAuthContext.Provider>
  )
}
